<template>
  <div>
    <div class="d-flex flex-column">
      <span class="combo-label">Combo</span>
      <span class="combo-name">{{ isGroup ? 'Cross Sell com Grupo de Produtos' : 'Cross Sell' }}</span>
    </div>
    <offer-sale-line :line-items="maxItem">
      <user-consumption :maximum-per-client="combo.trigger_rules.maximum_per_client" :user-sale-consumption-amount="combo.userSaleConsumptionAmount" />
    </offer-sale-line>

    <div class="d-flex flex-row align-center my-2" style="gap: 8px">
      <span class="trigger-target-label">Produtos gatilho ({{ triggerProductsAmount }})</span>
      <v-divider color="#00366D"></v-divider>
    </div>

    <industry-combo-sale-trigger
      v-for="offerSale in combo.trigger_products"
      :key="offerSale.sku"
      class="my-2"
      style="flex: 1"
      :offerSale="offerSale"
      :trigger-amount="combo.trigger_rules.trigger_amount"
      :is-activable="isActivable"
    />

    <div class="d-flex flex-row align-center my-4" style="gap: 8px">
      <span class="trigger-target-label">Produtos com desconto ({{ targetProductsAmount }})</span>
      <v-divider color="#00366D"></v-divider>
    </div>

    <cross-sell-offer-sale-target
      v-for="offerSale in combo.target_products"
      :key="offerSale.sku"
      class="my-2"
      style="flex: 1"
      :offerSale="offerSale"
      :target-discount="combo.target_rules.discount"
      :is-activable="isActivable"
    />
  </div>
</template>

<script>
import OfferSaleLine from './OfferSaleLine.vue'
import UserConsumption from './UserConsumption.vue'
import IndustryComboSaleTrigger from './IndustryComboSaleTrigger.vue'
import CrossSellOfferSaleTarget from './CrossSellOfferSaleTarget.vue'

export default {
  name: 'CrossSellOfferSaleBase',
  components: {
    OfferSaleLine,
    UserConsumption,
    IndustryComboSaleTrigger,
    CrossSellOfferSaleTarget,
  },
  props: {
    combo: {
      type: Object,
      required: true,
    },
    isActivable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isGroup() {
      return this.combo.trigger_products[0].group_id
    },
    userSaleConsumptionAmount() {
      return this.combo.trigger_products.reduce((acc, offerSale) => acc + offerSale.user_sale_consumption_amount, 0)
    },
    triggerProductsAmount() {
      return this.combo.trigger_products.length
    },
    targetProductsAmount() {
      return this.combo.target_products.length
    },
    maxItem() {
      return [
        {
          label: 'Máximo por CPF',
          value: this.combo.trigger_rules.maximum_per_client,
          format: 'text',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.combo-label {
  font-size: 14px;
  font-weight: 400;
  color: $cinza-0;
}

.combo-name {
  font-size: 14px;
  font-weight: 700;
  color: $cinza-d10;
}

.trigger-target-label {
  font-size: 14px;
  font-weight: 700;
  line-height: 16.8px;
  color: $marca-0-l10;
}
</style>
